export default __webpack_public_path__ + "static/media/galeria_de_atividades.3151a1a6.png";